import { useEffect, useRef, useState } from "react";
import { useViewContext } from "../../../../../context/View/ViewContext";
import MessagesContainer from "../../../messages/messageContainer";
import { useRouteLineContext } from "../../../../../context/MapViews/RouteLine/RouteLineContext";

const RouteLineMessages = () => {
  const [label, setLabel] = useState("");
  const [visible, setVisible] = useState(false);

  const { view } = useViewContext();

  const { selectedRouteLine } = useRouteLineContext();

  const labelTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const setLabelDebounced = (next: string) => {
    if (labelTimerRef.current) clearTimeout(labelTimerRef.current);
    labelTimerRef.current = setTimeout(() => setLabel(next), 500);
  };

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!view) return;

    const updateLabel = () => {
      const zoom = view.getZoom() ?? 0;
      if (zoom < 11) {
        setLabelDebounced("Please zoom in to view route lines");
      } else if (zoom >= 11 && !selectedRouteLine) {
        setLabelDebounced("Click on a route line to see services");
      } else {
        setLabelDebounced("");
      }
    };

    updateLabel();

    view.on("change:resolution", updateLabel);

    return () => {
      view.un("change:resolution", updateLabel);
      if (labelTimerRef.current) clearTimeout(labelTimerRef.current);
    };
  }, [view, selectedRouteLine]);

  return (
    <>
      {label && visible && (
        <MessagesContainer>
          <div className="rounded bg-light text-black text-center p-2">
            {label}
          </div>
        </MessagesContainer>
      )}
    </>
  );
};

export default RouteLineMessages;
